import { Link } from 'react-router';

import {
  ButtonField,
  Iconsvg,
  Tooltip,
  TooltipBody,
} from '@wk/components-react16';
import {
  IconDownload,
  IconLoader2,
  IconPlus,
} from '@tabler/icons-react';

import RunEvaluation from '@/features/runEvaluation/components/RunEvaluationDialog';

import ApplicationEvaluationsContent from './ApplicationEvaluationsContent';
import ApplicationEvaluationsFilters from './ApplicationEvaluationsFilters';
import ApplicationEvaluationsPagination from './ApplicationEvaluationsPagination';
import { useApplicationEvaluationsController } from './useApplicationEvaluationsController';

import './ApplicationEvaluationsPage.css';

const Evaluations = () => {
  const {
    contentProps,
    filtersProps,
    isExporting,
    isMobileViewport,
    onExportEvaluations,
    onboardApplicationPath,
    paginationProps,
    runEvaluationProps,
  } = useApplicationEvaluationsController();

  return (
    <div className="evaluations-page flex w-full flex-col gap-3 sm:h-full sm:gap-4">
      <div className="flex w-full items-center justify-between gap-x-4 gap-y-2 max-sm:flex-wrap">
        <div className="flex w-full items-center justify-between sm:w-auto">
          <h1 className="text-2xl font-bold">Evaluations</h1>
          {isMobileViewport ? (
            <div className="flex items-center gap-2">
              <ButtonField mode="text">
                <Link
                  to={onboardApplicationPath}
                  aria-label="Onboard Application"
                >
                  <IconPlus size={18} />
                </Link>
              </ButtonField>
              <ButtonField mode="text">
                <button
                  type="button"
                  aria-label="Export evaluations to CSV"
                  onClick={onExportEvaluations}
                  disabled={isExporting}
                >
                  {isExporting ? (
                    <IconLoader2 className="animate-spin" size={18} />
                  ) : (
                    <IconDownload size={18} />
                  )}
                </button>
              </ButtonField>
            </div>
          ) : null}
        </div>

        {!isMobileViewport ? (
          <div className="flex items-center justify-between gap-4 max-sm:w-full max-sm:flex-col max-sm:items-stretch">
            <ButtonField mode="text">
              <Link
                to={onboardApplicationPath}
                className="max-sm:block max-sm:w-full"
              >
                <span className="flex items-center gap-2 max-sm:w-full max-sm:justify-center">
                  <Iconsvg name="plus" />
                  <span>Onboard Application</span>
                </span>
              </Link>
            </ButtonField>
            <Tooltip position="top" targetSelector="#export-evaluations">
              <TooltipBody slot="tooltipBody">
                Exporting to CSV will only export the filtered evaluations.
              </TooltipBody>
            </Tooltip>
            <ButtonField mode="ghost">
              <button
                id="export-evaluations"
                onClick={onExportEvaluations}
                disabled={isExporting}
                className="export-button"
              >
                Export to CSV
                {isExporting ? (
                  <IconLoader2 className="animate-spin" size={16} />
                ) : null}
              </button>
            </ButtonField>
          </div>
        ) : null}
      </div>

      <ApplicationEvaluationsFilters {...filtersProps} />

      <div className="cg-ag-grid-field ag-theme-balham mt-2 flex w-full flex-col gap-4 sm:mt-5 sm:flex-1 sm:min-h-0">
        <ApplicationEvaluationsContent {...contentProps} />

        <div className="evaluations-pagination">
          <ApplicationEvaluationsPagination {...paginationProps} />
        </div>
      </div>

      <RunEvaluation {...runEvaluationProps} />
    </div>
  );
};

export default Evaluations;
